import { render, staticRenderFns } from "./ProductEditLabelsStockLocation.vue?vue&type=template&id=486d801e"
import script from "./ProductEditLabelsStockLocation.vue?vue&type=script&lang=ts"
export * from "./ProductEditLabelsStockLocation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('486d801e')) {
      api.createRecord('486d801e', component.options)
    } else {
      api.reload('486d801e', component.options)
    }
    module.hot.accept("./ProductEditLabelsStockLocation.vue?vue&type=template&id=486d801e", function () {
      api.rerender('486d801e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditLabelsStockLocation.vue"
export default component.exports